import { Amplify } from 'aws-amplify';
import { SETTINGS } from './settings';
//https://docs.amplify.aws/lib/restapi/getting-started/q/platform/js#manual-setup-import-existing-rest-api

const updatedConfig = {
    ...SETTINGS.aws.AwsConfig,
    Auth: {
        ...SETTINGS.aws.AwsConfig.Auth,
        authenticationFlowType: 'USER_SRP_AUTH',
        refreshTokenValidity: 30 // Set refresh token validity to 30 days
    }
};

Amplify.configure(updatedConfig);
